import {useNavigate} from "react-router-dom";
import {abacPoliciesSelector, useGetAllABACPoliciesQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ProtectedPage} from "../../components/page/ProtectedPage/ProtectedPage";
import {Card, Group, Menu, rem, Stack, Text, Title, UnstyledButton} from "@mantine/core";
import {IconChevronDown} from "@tabler/icons-react";
import {RouteBreadcrumbs} from "../../components/breadcrumb/RouteBreadcrumbs/RouteBreadcrumbs";
import {ABACPolicyDataTable} from "../../components/data-table/ABACPolicyDataTable/ABACPolicyDataTable";
import {PAGINATION_PAGE_SIZES} from "../../components/data-table/DataTable/usePagination";
import { HasAccess } from "../../components/auth/HasAccess/HasAccess";

export type ABACPolicyDataTablePageProps = {}

export const ABACPolicyDataTablePageRoute = () => {
  return (
    <ABACPolicyDataTablePage/>
  );
};

export const ABACPolicyDataTablePage = (props: ABACPolicyDataTablePageProps) => {

  const {t} = useTranslation(["translation", "common"]);
  const navigate = useNavigate()

  const [access, setAccess] = useState(false);

  const selectABACPolicies = useMemo(() => {
    return abacPoliciesSelector();
  }, []);

  const {abacPolicies, isLoading, error, refetch,} = useGetAllABACPoliciesQuery(access ? undefined : skipToken, {
    selectFromResult: (result) => ({
      ...result,
      abacPolicies: selectABACPolicies(result),
      isLoading: result.isLoading,
      error: result.error
    })
  });

  return (
    <ProtectedPage permissions={["abacpolicy_view"]} isLoading={isLoading} error={error} onAccess={setAccess}>
      <Stack h="100%" m="sm">
        <RouteBreadcrumbs/>
        <Card shadow="sm" padding="lg" mb="lg" radius="md" withBorder>
          <Group position="apart">
            <Title order={4}>
              {t("common.entity.abacpolicy.plural", "ABAC Policies", {ns: "common"})}
            </Title>
            <Menu
              width={260}
              position="bottom-end"
              transitionProps={{transition: "pop-top-right"}}
              withinPortal
            >
              <Menu.Target>
                <UnstyledButton>
                  <Group spacing={7}>
                    <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                      {t("common.actions.plural", "Actions", {ns: "common"})}
                    </Text>
                    <IconChevronDown size={rem(12)} stroke={1.5}/>
                  </Group>
                </UnstyledButton>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item onClick={() => refetch()}>
                  {t("common.actions.refresh", "Refresh", {ns: "common"})}
                </Menu.Item>
                <HasAccess permissions={["abacpolicy_create"]}>
                  <>
                    <Menu.Divider/>
                    <Menu.Item onClick={() => navigate("/abac-policies/form")}>
                      {t("common.action.new", "New", {ns: "common"})}
                    </Menu.Item>
                  </>
                </HasAccess>
              </Menu.Dropdown>
            </Menu>
          </Group>
        </Card>
        <ABACPolicyDataTable
          withBorder
          records={abacPolicies}
          recordsPerPageOptions={PAGINATION_PAGE_SIZES}
          fetching={isLoading}/>
      </Stack>
    </ProtectedPage>
  )
};
